import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthentificationService } from './authentification.service';
import { map } from 'rxjs';
import { User } from '../../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public user!:User;

  constructor(private http: HttpClient, private serviceAuthentification: AuthentificationService) {}

  public get() {
    const headers = this.serviceAuthentification.headers;

    return this.http.get(`${environment.urlServer}User`, { headers: headers, observe: 'response' }).pipe(map((response: HttpResponse<any>) => {
      return response.body;
    }));
  }

  public getDetails(ID_Tiers_Contact: string, ID_Tiers_Compte: string) {
    const headers = this.serviceAuthentification.headers;

    let queryParameters = new HttpParams();
    if (ID_Tiers_Compte)
      queryParameters = queryParameters.set('ID_Tiers_Compte', ID_Tiers_Compte);

    

    return this.http.get(`${environment.urlServer}User/` + ID_Tiers_Contact, { headers: headers, observe: 'response', params: queryParameters }).pipe(map((response: HttpResponse<any>) => {
      return response.body;
    }));
  }
}
